<template>
  <button
    :class="['tab-button', elClass, { active: activeTab === value }]"
    @click.prevent="$emit('click')"
  >
    {{ translateText ? $_translations.value[text] : text }}
  </button>
</template>

<script setup>
defineEmits(['click']);

defineProps({
  activeTab: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    default: '',
  },
  translateText: {
    type: Boolean,
    default: true,
  },
  elClass: {
    type: String,
    default: '',
  },
});
</script>
